import selfOrderSettings from './selfOrderSettings'

export default {
  namespaced: true,
  modules: {
    selfOrderSettings,
  },
}
